import React, { Fragment } from 'react';
import clsx from 'clsx';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import { LeftArrow, RightArrow } from './CarouselArrow.js';
export const Carousel = props => {
    const { className, items = [] } = props;
    return (React.createElement(ScrollMenu, { LeftArrow: LeftArrow, RightArrow: RightArrow, wrapperClassName: "relative overflow-hidden", scrollContainerClassName: clsx('flex space-s-2 overflow-auto scrollbar-hide px-2 sm:px-0', className), itemClassName: "flex" }, items.map(item => (React.createElement(Fragment, { key: item === null || item === void 0 ? void 0 : item.key }, item)))));
};
//# sourceMappingURL=Carousel.js.map